﻿/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import AbbreviationEditing from './abbreviationediting';
import AbbreviationUI from './abbreviationui';
import { Plugin } from '@ckeditor/ckeditor5-core';

export default class Abbreviation extends Plugin {
	static get requires() {
		return [AbbreviationEditing, AbbreviationUI];

	}
}